"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _Twilio = /*#__PURE__*/ _interop_require_default(require("./Twilio"));
const _ncplugin = require("~/types/nc-plugin");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let TwilioPlugin = class TwilioPlugin extends _ncplugin.XcWebhookNotificationPlugin {
    getAdapter() {
        return TwilioPlugin.notificationAdapter;
    }
    async init(config) {
        TwilioPlugin.notificationAdapter = new _Twilio.default(config);
        await TwilioPlugin.notificationAdapter.init();
    }
};
const _default = TwilioPlugin;
